import React from 'react';
import { BadgeCheck } from 'lucide-react';
import { cn } from '../lib/utils';

interface VerifiedBadgeProps {
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  showTooltip?: boolean;
}

const VerifiedBadge = ({ className, size = 'md', showTooltip = false }: VerifiedBadgeProps) => {
  const sizeClasses = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  return (
    <div className={cn('inline-flex items-center group relative', className)}>
      <BadgeCheck 
        className={cn(
          'text-accent transition-transform duration-200 group-hover:scale-110', 
          sizeClasses[size]
        )} 
      />
      {showTooltip && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-surface-dark text-neutral-light text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
          Verified Account
        </div>
      )}
    </div>
  );
};

export default VerifiedBadge;